// generated by genversion
export var version = '3.2.7';
//# sourceMappingURL=version.js.map